module.exports = __webpack_public_path__ + "img/download_point_1.04d5331b.png";